// キャッチ設定モーダル
const ModalAiCatch = {
  namespaced: true,

  state: {
    modal: false,
    modalWidth: 600,
    modalHeight: 700,
    convertResults: [],
    convertData: {},
    activeTab: null,
    isLoading: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getModalWidth: state => {
      return state.modalWidth
    },
    getModalHeight: state => {
      return state.modalHeight
    },
    getConvertResult: state => {
      return state.convertResults
    },
    getConvertData: state => {
      return state.convertData
    },
    getActiveTab: state => {
      return state.activeTab
    },
    getIsLoading: state => {
      return state.isLoading
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setModalWidth(state, width) {
      state.modalWidth = width
    },
    setModalHeight(state, height) {
      state.modalHeight = height
    },
    setConvertResult(state, data) {
      state.convertResults = data
    },
    setConvertData(state, data) {
      state.convertData = data
    },
    setActiveTab(state, tab) {
      state.activeTab = tab
    },
    setIsLoading(state, val) {
      state.isLoading = val
    },
  },
  actions: {
    // モーダル開閉
    toggle({ state, dispatch }) {
      if (state.modal) {
        dispatch('hide')
      } else {
        dispatch('show')
      }
    },
    show({ commit }) {
      const aiCatchWindowParams = JSON.parse(localStorage.getItem('rentAiCatchWindowParams'))
      if (aiCatchWindowParams) {
        commit('setModalWidth', aiCatchWindowParams.width)
        commit('setModalHeight', aiCatchWindowParams.height)
      }
      commit('setModal', true)
    },
    hide({ commit }) {
      commit('setModal', false)
    },
  },
}

export default ModalAiCatch
